import { useQuery } from "@tanstack/react-query";
import { fetchAgreementWithPrices } from "./endpoints";
export const useAgreementsWithPrices = (customerId, showDetailedPricesForCustomerView) => {
    var _a, _b, _c;
    const { data: agreementsWithPrices, refetch, isFetching, isLoading, error, } = useQuery({
        queryKey: ['agreements-with-prices', customerId],
        queryFn: () => fetchAgreementWithPrices(customerId),
        enabled: showDetailedPricesForCustomerView && !!customerId,
    });
    const agreementsErrorMessage = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data.message) || ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.title) || '';
    return {
        data: agreementsWithPrices,
        refetch,
        isFetching,
        isLoading,
        agreementsErrorMessage,
    };
};
